import { StaticImageData } from 'next/image';

import CalmLogoGradient from '@/../public/_n/images/calm-logo-gradient.png';
import CalmLogoWhite from '@/../public/_n/images/calm-logo.png';
import CalmSleepLogoGradient from '@/../public/_n/images/calm-sleep-logo-gradient.png';
import CalmSleepLogoWhite from '@/../public/_n/images/calm-sleep-logo.png';
import Image from '@/components/image/NextImage';
import useIsCalmSleepApp from '@/hooks/useIsCalmSleepApp';

import { BrandingWrapper, ImageContainer } from './styles';

type BrandingProps = {
	backgroundColor?: string;
	coBranded?: {
		src: StaticImageData | string;
		alt: string;
	};
};

const Branding = ({ backgroundColor, coBranded }: BrandingProps) => {
	const isCalmSleepApp = useIsCalmSleepApp();

	const CalmLogo = backgroundColor !== 'gray0' ? CalmLogoWhite : CalmLogoGradient;
	const CalmSleepLogo = backgroundColor !== 'gray0' ? CalmSleepLogoWhite : CalmSleepLogoGradient;

	return (
		<BrandingWrapper>
			<ImageContainer>
				<Image
					alt={isCalmSleepApp ? 'Calm Sleep Logo' : 'Calm Logo'}
					src={isCalmSleepApp ? CalmSleepLogo : CalmLogo}
					layout="fill"
					objectFit="contain"
				/>
			</ImageContainer>
			{coBranded && (
				<>
					{typeof coBranded.src === 'string' ? (
						<ImageContainer>
							<Image src={coBranded.src} alt={coBranded.alt} layout="fill" objectFit="contain" />
						</ImageContainer>
					) : (
						<Image src={coBranded.src} alt={coBranded.alt} objectPosition="bottom" />
					)}
				</>
			)}
		</BrandingWrapper>
	);
};

export default Branding;
